import React from "react";

// WhatsApp click-to-chat with the business
const WHATSAPP_NUMBER = "17196784639"; // +1 (719) 678-4639
const WHATSAPP_MESSAGE = encodeURIComponent(
    "Hi Ruiz Concret3! I'm interested in a free quote for a concrete project."
);
const WA_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${WHATSAPP_MESSAGE}`;

// Official WhatsApp glyph — kept as inline SVG so no extra dependency
const WhatsAppIcon = ({ className = "" }) => (
    <svg
        viewBox="0 0 32 32"
        aria-hidden="true"
        className={className}
        fill="currentColor"
    >
        <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.406-.545-.489-1.145-1.435-1.595-2.05a.629.629 0 0 1-.135-.407c0-.596.98-.94.98-1.508 0-.246-1.017-2.548-1.183-2.716a.813.813 0 0 0-.579-.201c-.324 0-.646.036-.972.036-.489 0-.907.361-1.098.706-.244.435-.435.926-.435 1.454 0 1.208.501 2.32 1.147 3.335 1.223 1.919 3.104 3.804 5.145 4.802.635.31 1.253.556 1.94.694.362.075.741.075 1.104.135.55.09 1.203-.056 1.646-.244.501-.213 1.29-.867 1.502-1.375.098-.239.147-.489.147-.732 0-.55-1.508-1.208-1.807-1.208-.221 0-.463.207-.667.397zM16 6c-5.523 0-10 4.477-10 10 0 1.777.464 3.443 1.267 4.888L6 26l5.257-1.379A9.951 9.951 0 0 0 16 26c5.523 0 10-4.477 10-10S21.523 6 16 6zm0 18.286a8.253 8.253 0 0 1-4.256-1.184l-.303-.183-3.121.818.833-3.043-.198-.315A8.279 8.279 0 0 1 7.714 16C7.714 11.437 11.437 7.714 16 7.714S24.286 11.437 24.286 16 20.563 24.286 16 24.286z" />
    </svg>
);

export default function WhatsAppButton() {
    return (
        <a
            href={WA_URL}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Chat with Ruiz Concret3 on WhatsApp"
            data-testid="whatsapp-fab"
            className="fixed bottom-6 right-6 md:bottom-8 md:right-8 z-40 group"
        >
            <span className="absolute inset-0 rounded-full bg-[#25d366] opacity-40 animate-ping" />
            <span className="relative flex items-center gap-3 bg-[#25d366] hover:bg-[#1ebe57] text-white pl-4 pr-5 py-3 md:py-4 rounded-full shadow-lg shadow-black/40 transition-colors">
                <WhatsAppIcon className="w-6 h-6 md:w-7 md:h-7" />
                <span className="hidden sm:inline font-bold tracking-wide text-sm md:text-base">
                    WhatsApp
                </span>
            </span>
        </a>
    );
}
